import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';
interface FAQItem {
  q: string;
  a: string;
}
export const FAQAccordion = ({
  items
}: {
  items: FAQItem[];
}) => {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <div className="space-y-4 text-left" data-id="element-6">
      {items.map((item, i) => <div key={i} className="bg-card rounded-2xl shadow-sm border border-border overflow-hidden transition-all duration-300" data-id="element-7">
          <button className="w-full px-6 py-5 flex items-center justify-between text-left focus:outline-none" onClick={() => setOpenIndex(openIndex === i ? null : i)} data-id="element-8">
            <span className="font-display font-bold text-foreground pr-4" data-id="element-9">
              {item.q}
            </span>
            <ChevronDown className={`w-5 h-5 text-muted-foreground transition-transform duration-300 shrink-0 ${openIndex === i ? 'rotate-180' : ''}`} data-id="element-10" />
          </button>
          <div className={`px-6 overflow-hidden transition-all duration-300 ease-in-out ${openIndex === i ? 'max-h-96 pb-5 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-11">
            <p className="text-muted-foreground leading-relaxed" data-id="element-12">{item.a}</p>
          </div>
        </div>)}
    </div>;
};